import api from '../api';
import { uploadImage } from './image-service';

export async function getTrips() {
    const response = await api.get(`/trip`);
    return response.data;
}

export async function createTrip(payload) {
  const { image, ...tripData } = payload;
  let coverImageUrl;

  // 1. Upload image first (if any)
  if (image) {
    try {
      coverImageUrl = await uploadImage(image, 'Trip');
    } catch (err) {
      console.error('Trip image upload failed:', err);
      coverImageUrl = null;
    }
  }

  // 2. Create trip with metadata + image URL (if available)
  const response = await api.post('/trip', {
    ...tripData,
    ...(coverImageUrl ? { coverImageUrl } : {})
  });

  return response.data;
}

export async function updateTrip(id, payload = {}, imageFile = null) {
  try {
    let coverImageUrl;

    // 1. Upload new image if provided
    if (imageFile) {
      try {
        coverImageUrl = await uploadImage(imageFile, 'Trip');
      } catch (err) {
        console.error('Trip image upload failed:', err);
        coverImageUrl = null;
      }
    }

    // 2. Build payload
    const updatePayload = {
      ...payload,
      ...(coverImageUrl ? { coverImageUrl } : {})
    };

    if (!Object.keys(updatePayload).length) return true; // nothing to update

    // 3. Update trip
    const response = await api.put(`/trip/${id}`, updatePayload);
    return response.status === 204 || response.status === 200;
  } catch (err) {
    console.error('Error updating trip metadata:', err);
    return false;
  }
}

export async function deleteTrip(id) {
    try {
        await api.delete(`/trip/${id}`);
        return true;
    } catch (err) {
        console.error('Failed to delete trip:', err);
        return false;
    }
}

export async function getTripSteps(tripId) {
    const response = await api.get(`/trips/${tripId}/steps`);
    return response.data;
}

export async function createStep(tripId, payload) {
  const { image, ...stepData } = payload;
  let imageUrls;

  if (image) {
    try {
      const imageUrl = await uploadImage(image, 'TripStep');
      imageUrls = [imageUrl];
    } catch (err) {
      console.error('TripStep image upload failed:', err);
      imageUrls = []; 
    }
  }

  const response = await api.post(`/trips/${tripId}/steps`, {
    ...stepData,
    imageUrls
  });

  return response.data;
}

export async function updateStep(tripId, stepId, stepData = {}, imageFile = null) {
  try {
    let imageUrls;

    // 1. If there's a new image, upload it first
    if (imageFile) {
      try {
        const url = await uploadImage(imageFile, 'TripStep');
        imageUrls = [url];
      } catch (err) {
        console.error('TripStep image upload failed:', err);
        imageUrls = []; // optional: leave empty or handle differently
      }
    }

    // 2. Combine metadata with image URLs if any
    const payload = {
      ...stepData,
      ...(imageUrls ? { imageUrls } : {}),
    };

    // 3. Skip update if nothing to send
    if (!Object.keys(payload).length) return true;

    const response = await api.put(`/trips/${tripId}/steps/${stepId}`, payload);
    return response.status === 204 || response.status === 200;
  } catch (err) {
    console.error('Error updating trip step:', err);
    return false;
  }
}

export async function deleteStep(tripId, stepId) {
    try {
        await api.delete(`/trips/${tripId}/steps/${stepId}`);
        return true;
    } catch (err) {
        console.error('Failed to delete trip:', err);
        return false;
    }
}